import type { SearchSelectItem } from '@/components/searchSelect/searchSelect';
import { tr } from '@/i18n/tr';

/**
 * What the category chip says and what its menu lists, once the chip itself is
 * the subcategory dropdown's trigger.
 */

/** The clear row's id. Empty, because that is what "no product filter" is. */
const CLEAR_ID = '';

/**
 * The category's products, preceded by the row that clears the subcategory.
 *
 * Tapping a selected chip used to deselect its category; it now opens this
 * menu, so the menu has to carry the way back out. The category itself is
 * cleared by the "Tümü" chip at the head of the row, which already means
 * exactly that.
 */
export function productMenuItems(products: readonly SearchSelectItem[]): SearchSelectItem[] {
  // A category with no products has nothing to offer and nothing to clear:
  // opening a one-row menu that only undoes itself is worse than no menu.
  if (products.length === 0) return [];
  return [{ id: CLEAR_ID, name: tr.explore.allProducts }, ...products];
}

/**
 * The chip's text carries the narrower fact: the chosen subcategory once there
 * is one. Showing "Kategori: Alt" would widen a chip sitting in a row that
 * already scrolls sideways.
 */
export function categoryChipLabel(
  category: { name: string },
  product: { name: string } | undefined
): string {
  return product?.name ?? category.name;
}

/**
 * Whose icon the chip draws — the same subject as its label, so icon and text
 * always name one thing (never the category's apple beside "Muz").
 */
export function categoryChipIcon<T extends { icon: string; iconKey?: string }>(
  category: T,
  product: T | undefined
): T {
  return product ?? category;
}
